import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OverlayComponent} from './overlay.component';
import {FieldComponent} from './components/field/field.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {FormComponent} from './components/form/form.component';
import {ButtonOverlayComponent} from './components/button-overlay/button-overlay.component';
import {ImageOverlayComponent} from './components/image-overlay/image-overlay.component';
import {DefaultOverlayComponent} from './components/default-overlay/default-overlay.component';

@NgModule({
    declarations: [OverlayComponent, FieldComponent, FormComponent, ButtonOverlayComponent, ImageOverlayComponent, DefaultOverlayComponent],
    exports: [
        OverlayComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        SharedModule
    ]
})
export class OverlayModule {
}
